import { render, staticRenderFns } from "./CreateOrUpdateAppointment.vue?vue&type=template&id=6d70214a&scoped=true"
import script from "./CreateOrUpdateAppointment.vue?vue&type=script&lang=js"
export * from "./CreateOrUpdateAppointment.vue?vue&type=script&lang=js"
import style0 from "./CreateOrUpdateAppointment.vue?vue&type=style&index=0&id=6d70214a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d70214a",
  null
  
)

export default component.exports